export const TS_CONFIG_FILENAME = "tsconfig.json";
